const state = {
  loginVisible: false, // 登录注册弹窗
  firstLoginVisible: false,  // 首次登录页面
  firstLoginInfo: {},  // 首次登陆填写的用户信息
  userInfo: {
    additional: {}
  }, // 用户信息
  cartNum: 0, // 购物车商品数量
  targetRoute: {
    path: '/',
    query: {}
  },  // 目标路径
};

export default state



// WEBPACK FOOTER //
// ./src/store/state.js